import { useState } from "react";
import { dataesalab } from "./constants"
import closeicon from "./esalab/whiteclose.png"
import { useNavigate} from "react-router-dom";
import { HashLoader } from "react-spinners";

export default function QuickView(props){
    const data = dataesalab[props.index];
    const [load,setload] = useState(false)
    const navigate = useNavigate();
    async function handleClick(event){
        setload(true);
        event.preventDefault();
        props.setBook(data.Title);
        await sleep(1000);
        setload(false);
    }
    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    async function handlepagetransition(event,href){
        event.preventDefault();
        props.setView(false);
        const body=document.querySelector('body');
        body.classList.add('page-transition');
        await sleep(500);
        navigate(href);
        window.scrollTo(0, 0);
        await sleep(500);
        body.classList.remove('page-transition'); 
    }
    if(props.view){
        return <div className="backdiv">
        <img alt="close" src={closeicon} style={{width:"5vw",alignSelf:"flex-end",marginRight:"3vw",cursor:"pointer"}} onClick={()=>{props.setView(false)}}/>
            <div style={{display:"flex",flexDirection:"row",gap:"5vw"}}>
                <div>
                    <button className="submit greenbutton" onClick={()=>props.setInd("prev")}>Previous</button>
                </div>
                <div>
                    <button className="submit greenbutton" onClick={()=>props.setInd("next")}>Next</button>
                </div>
            </div>
            <div className="quickviewdiv" key={props.index}>
            <img alt="data" src={data.imgurl} className="quickviewimage"/>
            <form className="quickform">
                <h1 style={{color:"black",fontFamily:"Ubuntu"}} className="slidertextOne qt">{data.Title}</h1>
                <p className="slidertextTwo qtt" style={{color:"#2d85bb"}}>{data.Price}</p>
                <button type="submit" key={props.bookdata} style={props.bookdata.includes(data.Title)?{backgroundColor:"green"}:null} className="submit greenbutton" onClick={handleClick}>{load?<HashLoader loading={load}/>:props.bookdata.includes(data.Title)?"Added":"Add to Cart"}</button>
            </form>
        </div>
        <div key={props.bookdata}>
            <a href="/book" className="submit greenbutton" onClick={(event)=>handlepagetransition(event,"/book")}>Finalize Booking</a>
        </div>
    </div>
    }else{
        return null;
    }
}